import { EventManager, Events } from "@events";
import Enumerable from "linq";
import { ref } from "vue";

export function usePeerState(rtcId) {
  const eventEmitter = EventManager.getEventEmitter(rtcId);

  const peers = ref([]);
  const addPeer = (type) => {
    // find max index for type
    var maxIndex =
      Enumerable.from(peers.value)
        .where((x) => x.type === type)
        .orderByDescending((x) => x.index)
        .firstOrDefault()?.index ?? -1;

    // add new peer with max index + 1
    var peerIndex = maxIndex + 1;

    const peer = {
      type,
      index: peerIndex,
      camera: "f",
      peerName: `${type}-${peerIndex}`,
    };

    peer.videoElementReadyPromise = new Promise((resolve) => {
      peer.videoElementReadyResolver = resolve;
    });

    peers.value.push(peer);
    console.log("call state " + rtcId + " add peer " + peer.peerName);

    eventEmitter.emit(Events.PeerAdded, {
      peer,
      type,
    });

    return peer;
  };

  const setPeerVideoElement = (peerName, video) => {
    console.log("setPeerVideoElement", peerName, video);
    var peer = Enumerable.from(peers.value)
      .where((x) => x.peerName === peerName)
      .firstOrDefault();

    if (peer) {
      peer.video = video;
      if (peer.srcObject) {
        console.log("peer has srcObject, setting video srcObject");
        video.srcObject = peer.srcObject;
      }
      console.log("resolving video element ready promise for peer " + peerName);
      peer.videoElementReadyResolver();
    }
  };

  const setPeerSrcObject = (peerName, srcObject) => {
    console.log("setPeerSrcObject", peerName, srcObject);
    var peer = Enumerable.from(peers.value)
      .where((x) => x.peerName == peerName)
      .firstOrDefault();

    if (peer) {
      console.log("setting PeerSrcObject", peerName, srcObject);
      peer.srcObject = srcObject;
      if (peer.video) {
        console.log("peer has video element, setting srcObject");
        peer.video.srcObject = srcObject;
        peer.video.play();
      }
    }
  };

  const getPeer = (peerName) => {
    return Enumerable.from(peers.value)
      .where((x) => x.peerName == peerName)
      .firstOrDefault();
  }

  const getPeerWithType = (type) => {
    return Enumerable.from(peers.value)
      .where((x) => x.type == type)
      .firstOrDefault();
  }

  const removePeer = (peer) => {
    peers.value = peers.value.filter((p) => p != peer);
    eventEmitter.emit(Events.PeerRemoved, { peer });
  };

  const setPeerCamera = (peerName, camera) => {
    console.log("setPeerCamera", peerName, camera);
    var peer = Enumerable.from(peers.value)
      .where((x) => x.peerName === peerName)
      .firstOrDefault();

    if (peer) {
      // f or b
      peer.camera = camera;
    }
  };

  return {
    peers,
    addPeer,
    removePeer,
    getPeer,
    getPeerWithType,
    setPeerVideoElement,
    setPeerSrcObject,
    setPeerCamera,
  };
}
